export default __webpack_public_path__ + "static/media/attachment.b7baf928.svg";